export const getRefreshTokenName = (tokenName: string) => `${tokenName}_r`;
